import { getCharts, getChartsSection } from '@/api/charts'
const state = {
  availablecharts: [],
  selectedchart: {},
  chartsection: []
}

const mutations = {
  SET_CHARTS: (state, availablecharts) => {
    state.availablecharts = availablecharts
  },
  SET_CHART: (state, chart) => {
    state.selectedchart = chart
  },
  SET_CHARTSECTION: (state, chart) => {
    state.chartsection = chart
  }
}

const actions = {
  loadcharts({ commit }) {
    return new Promise((resolve, reject) => {
      getCharts().then((response) => {
        commit('SET_CHARTS', response.data)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_CHARTS', [])
        reject()
      })
    })
  },
  setchart({ commit }, chart) {
    return new Promise((resolve, reject) => {
      commit('SET_CHART', chart)
      getChartsSection(chart).then((response) => {
        commit('SET_CHARTSECTION', response.data)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_CHART', [])
        reject()
      })
      resolve()
    })
  },
  setchartexport({ commit }, chart) {
    return new Promise((resolve, reject) => {
      getChartsSection(chart).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        reject()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
